const PROD = {
  // BASE_URL: "http://apibeta.itus.com"
  BASE_URL: "https://api.ituscapital.com",
};

const BETA = {
  // BASE_URL: 'https://apibeta.pathfinder.com'
  BASE_URL: "https://api-staging.ituscapital.com",
  //BASE_URL: "http://localhost:8000",
};

const DEV = {
  //BASE_URL: "https://api-staging.ituscapital.com"
  BASE_URL: "http://localhost:8000",
};

const MAP = {
  production: PROD,
  beta: BETA,
  development: DEV,
};

// Safely access process.env with fallbacks
const getEnv = (key, defaultValue) => {
  if (typeof process !== "undefined" && process.env && process.env[key]) {
    return process.env[key];
  }
  return defaultValue;
};

const Config =
  getEnv("REACT_APP_ENV") === "beta"
    ? MAP["beta"]
    : MAP[getEnv("NODE_ENV", "development")] || MAP["development"];

export default Config;
